import * as CoreFns from './utilities/CoreFns';
import * as ResponsiveFns from './utilities/ResponsiveFns';


function checkPMatch(aPiece, bPiece){
  if (aPiece.p.length === bPiece.p.length){
    var len = aPiece.p.length;
    for (var i = 0; i < len; i++){
      if (aPiece.p[i].t === bPiece.p[i].t){
        if (aPiece.p[i].t === 'oP'){
          if (aPiece.p[i].ti !== bPiece.p[i].ti){
            return false;
          }
        }
      }else{
        return false;
      }
    }
    return true;
  }else{
    return false;
  }
}


function checkMatches(bPiece, aPiece){
  var at = aPiece.t;
  var bt = bPiece.t;

    if (at === bt){
      if (at === 'br'){
        return true;
      }else if (at === 'h'){
        if (aPiece.n === bPiece.n){
          return true;
        }
      }else if (at === 'a'){
        if (aPiece.i === bPiece.i){
          return true;
        }
      }else if (at === 't'){
        if (aPiece.v === bPiece.v){
          return ResponsiveFns.compareStyleEquality(aPiece.s, bPiece.s);
        }
      }else if (at === 'tb'){
        if (aPiece.v.length === bPiece.v.length){
          var gotError = false;
          for (var i = 0; i < aPiece.v.length; i++){
            if (aPiece.v[i].u === bPiece.v[i].u){
            }else{
              gotError = true;
              break;
            }
          }

          if (!gotError){
            return ResponsiveFns.compareStyleEquality(aPiece.s, bPiece.s);
          }
        }
      }else if (at === 'g'){ //this is the start of the formula pieces;
        if (aPiece.v === bPiece.v && aPiece.ti === bPiece.ti){
          return true;
        }
      }else if (at === 'eS'){ 
        if (aPiece.i === bPiece.i && aPiece.s === bPiece.s && aPiece.n === bPiece.n && aPiece.a.join(' ') === bPiece.a.join(' ')){
          return checkPMatch(aPiece, bPiece);
        }
      }else if (at === 'eV'){ 
        if (aPiece.i === bPiece.i && aPiece.s === bPiece.s){
          return checkPMatch(aPiece, bPiece);
        }
      }else if (at === 'pl'){ 
        if (aPiece.v === bPiece.v && aPiece.p === bPiece.p && aPiece.ti === bPiece.ti){
          return true;
        }
      }else if (CoreFns.directV(at)){ //this is the start of the formula pieces;
        if (aPiece.v === bPiece.v){
          return true;
        }
      }else if (at === 'u' || at === 'footer'){
        return true;
      }else if (at === 'pa' || at === 'al'){
        if (aPiece.v.join(' ') === bPiece.v.join(' ')){
          return true;
        }
      }else if (CoreFns.withP(at)){
        if (aPiece.v === bPiece.v || ((at === 'aC') && aPiece.v.k === bPiece.v.k && aPiece.v.s === bPiece.v.s) || ((at === 'gV' || at === 'inP') && aPiece.v.join(' ') === bPiece.v.join(' '))){
          return checkPMatch(aPiece, bPiece);
        }
      }
    }    

  return false;
}


function lLoop(a,b,d){
  var bVal = b.length;
  var aVal = a.length;

  if(aVal === 0){
    return [{t:'a',p:0,d,n:b}];
  } 
  if(bVal === 0){
    return [{t:'d',p:0,l:aVal,d}];
  } 

  var matrix = [];

  // increment along the first column of each row
  var i;
  for(i = 0; i <= b.length; i++){
    matrix[i] = [i];
  }

  // increment each column in the first row
  var j;
  for(j = 0; j <= a.length; j++){
    matrix[0][j] = j;
  }

  // Fill in the rest of the matrix
  for(i = 1; i <= b.length; i++){
    for(j = 1; j <= a.length; j++){
        var bPiece = b[i-1];
        var aPiece = a[j-1];
        var isMatch = checkMatches(bPiece, aPiece);
        if (isMatch){
          matrix[i][j] = matrix[i-1][j-1];
        }else{
          matrix[i][j] = Math.min(matrix[i-1][j-1] + 1, // substitution
                                  Math.min(matrix[i][j-1] + 1, // insertion
                                           matrix[i-1][j] + 1)); // deletion
        }
    }
  }

  var path = [];


  do{
    var up = 99999999;
    var left = 99999999;
    var upLeft = 99999999;
    if (bVal > 0 && aVal > 0){
        upLeft = matrix[bVal - 1][aVal - 1];
    }
    if (aVal > 0){
      up = matrix[bVal][aVal-1];
    }
    if (bVal > 0){
      left = matrix[bVal -1][aVal];
    }
    if (upLeft <=up && upLeft <= left){
      bVal --;
      aVal --;
        var oldPiece1 = a[aVal];
        var newPiece1 = b[bVal];
        if (checkMatches(oldPiece1, newPiece1)){
        }else{
          path.push({t:'r', p:bVal, n:[newPiece1],d});
        }
    }else if (up < left){
      aVal --;
      path.push({t:'d', p:bVal,l:1, d});
    }else{
      bVal --;
      var n1 = b[bVal];
      path.push({t:'a',p:bVal, n:[n1],d});
    }

  } while (bVal + aVal > 0)
  return path;
}


function expandText(a){
  var aOut = [];
  a.forEach((anA, index)=>{
    var at = anA.t;

    if (CoreFns.directV(at) || CoreFns.withP(at) || at === 'h' || at === 'br' || at === 'a' || at === 'u' || at === 'g'  || at === 'footer' || at === 'inP' || at === 'd' || at === 'eS' || at === 'eV' || at === 'pa' || at === 'al'|| at === 'pl'){
      aOut.push(anA);
    }else if (at === 't'){
      var v = anA.v;
      for (var i = 0; i < v.length; i++){
        aOut.push({t:'t',v:v.substr(i, 1),s:anA.s});
      }
    }else if (at === 'tb'){
      var v1 = anA.v;
      for (var i5 = 0; i5 < v1.length; i5++){
        aOut.push({t:'tb',v:[v1[i5]],s:anA.s});
      }
    }
  })
  return aOut;
}
export default function levenshtein(a, b, entityType) {
  var aPrime = expandText(a);
  var bPrime = expandText(b);

  var path = lLoop(aPrime, bPrime,[]);
  var rPath = path.reverse();

  var consol = [];

  rPath.forEach((aBit, index)=>{
    var prev = false;
    if (consol.length > 0){
      prev = consol[consol.length - 1];
    }
    if (prev && prev.d.join(" ") === aBit.d.join(" ")){
      if (aBit.t === prev.t && aBit.p === prev.p && aBit.t === 'd'){
        prev.l = prev.l + aBit.l
      }else if (aBit.t === prev.t && (aBit.t === 'a' || aBit.t === 'r') && prev.p + prev.n.length === aBit.p){
        if (aBit.q === 1){
          prev.n = prev.n + aBit.n;
        }else{
          prev.n = prev.n.concat(aBit.n);
        }
      }else{
        consol.push(aBit);
      }
    }else{
      consol.push(aBit);
    }
  })

  var consol1 = [];
  consol.forEach((aC1, index)=>{
    if (aC1.t === 'a' || aC1.t === 'd'){
      consol1.push({...aC1,...{w:entityType,q:1}});
    }else if (aC1.t === 'r'){
      consol1.push({t:'d',p:aC1.p,d:aC1.d,l:aC1.n.length,w:entityType,q:1});
      consol1.push({t:'a',p:aC1.p,d:aC1.d,n:aC1.n,w:entityType,q:1});
    }
  })

  var consol2 = [];
  consol1.forEach((aC2, index)=>{
    var prev = false;
    if (consol2.length > 0){
      prev = consol2[consol2.length - 1];
    }
    if (prev && prev.d.join(" ") === aC2.d.join(" ")){
      if (aC2.t === prev.t && aC2.p === prev.p && aC2.t === 'd'){
        prev.l = prev.l + aC2.l
      }else if (aC2.t === prev.t && aC2.t === 'a' && prev.p + prev.n.length === aC2.p){
        prev.n = prev.n.concat(aC2.n);
      }else{
        consol2.push(aC2);
      }
    }else{
      consol2.push(aC2);      
    }
  })

  return consol2;
}